<template>
	<div ref="overlayWrapper">
		<div class="form-title" style="margin-bottom: 35px; text-transform: unset">
			Chuyển hướng
		</div>

		<div class="policy">
			<p>
				Bạn sắp được điều hướng tới: {{ redirectUrl }}
			</p>
		</div>


		<a href="javascript:void(0)" @click="redirectToOtherURL" class="btn-next" style="margin-bottom: 40px">Tôi đồng ý</a>

		<a href="javascript:void(0)" class="btn-back" style="margin-bottom: 100px" @click="backStep">
			<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
				<path
					d="M6.72488 10.4525L13.6911 17.09C13.8074 17.2008 13.9618 17.2626 14.1224 17.2626C14.283 17.2626 14.4374 17.2008 14.5536 17.09L14.5611 17.0825C14.6177 17.0287 14.6627 16.9641 14.6935 16.8924C14.7242 16.8207 14.7401 16.7436 14.7401 16.6656C14.7401 16.5876 14.7242 16.5104 14.6935 16.4387C14.6627 16.3671 14.6177 16.3024 14.5611 16.2487L8.00113 9.9987L14.5611 3.7512C14.6177 3.69749 14.6627 3.63283 14.6935 3.56116C14.7242 3.4895 14.7401 3.41232 14.7401 3.33433C14.7401 3.25634 14.7242 3.17916 14.6935 3.10749C14.6627 3.03583 14.6177 2.97117 14.5611 2.91745L14.5536 2.90995C14.4374 2.79915 14.283 2.73733 14.1224 2.73733C13.9618 2.73733 13.8074 2.79915 13.6911 2.90995L6.72488 9.54745C6.66362 9.60582 6.61484 9.67603 6.58152 9.75381C6.54819 9.83159 6.53101 9.91533 6.53101 9.99995C6.53101 10.0846 6.54819 10.1683 6.58152 10.2461C6.61484 10.3239 6.66362 10.3941 6.72488 10.4525Z"
					fill="#0355CE" />
			</svg>
			Quay lại
		</a>
	</div>
</template>
<script>
import { useAuthStore, useUtilsStore } from "@/store";
export default {
	data() {
		const authStore = useAuthStore();
		return {
			showWarning: false,
			textWarinng: null,
			redirectUrl: authStore.redirectUrl,
			redirectParam: history.state
		};
	},
	methods: {
		backStep() {
			this.$router.back();
		},
		redirectToOtherURL() {
			useUtilsStore().redirectWithParams(this.redirectUrl, this.redirectParam);
		},
	},
};
</script>
<style scoped>
.policy {
	width: 100%;
	max-width: 400px;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px;
	margin: 0 auto;
	padding-right: 20px;
	margin-bottom: 40px;
}

.policy ul li {
	margin-bottom: 5px;
}

.policy p {
	margin-bottom: 10px;
}

.policy a {
	color: #0355ce !important;
	margin-bottom: 10px;
}

.policy a {
	position: relative;
}

.policy a::before {
	content: "";
	position: absolute;
	width: 100%;
	height: 1px;
	border-radius: 4px;
	background-color: #0355ce;
	bottom: 5px;
	left: 0;
	transform-origin: right;
	transform: scaleX(0);
	transition: transform 0.3s ease-in-out;
}

.policy a:hover::before {
	transform-origin: left;
	transform: scaleX(1);
}
</style>